module.exports = "/packs/016-337fd25769533f73784532ce613436e1.jpg";